import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Link } from 'react-router-dom';
import moment from 'moment';

import VerbButton, { VERB_BUTTON_TYPE } from '../VerbButton';
import VerbTable from '../VerbTable';
import VerbSelect from './inputs/VerbSelect';
import TextInput from './inputs/TextInput';

export default class AdminResourceManagementTable extends PureComponent {
    static propTypes = {
        fields: PropTypes.object,
        currentValues: PropTypes.object,
        mediaMetadata: PropTypes.array,
        label: PropTypes.string,
        team: PropTypes.object,
        resourcesParentType: PropTypes.string,
        RESOURCE_PERMISSION_TYPES: PropTypes.object,
        isVerbAdmin: PropTypes.bool,
        isContentAdmin: PropTypes.bool,
        isAccountOwner: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedResourceUrl: '',
            selectedResourceName: '',
            selectedResourcePermission: '',
            selectedResourceDisplayName: '',
            everythingSector: ''
        };
    }

    componentDidMount() {
        const { resourcesParentType, RESOURCE_PERMISSION_TYPES } = this.props;
        if (resourcesParentType === 'teams') {
            this.setState({
                selectedResourcePermission: RESOURCE_PERMISSION_TYPES.WHOLE_TEAM.value,
                everythingSector: RESOURCE_PERMISSION_TYPES.WHOLE_TEAM.value
            });
        } else if (resourcesParentType === 'group-learning') {
            this.setState({
                selectedResourcePermission: RESOURCE_PERMISSION_TYPES.ALL.value,
                everythingSector: RESOURCE_PERMISSION_TYPES.ALL.value
            });
        }
    }

    _buildTable = (fields, currentValues) => {
        const { RESOURCE_PERMISSION_TYPES } = this.props;
        if (fields && fields.length > 0) {
            return (
                <VerbTable striped={false} bordered={false} hover={true} className={'resource-management-table'}>
                    <thead>
                        <tr>
                            <th className={'col-1 buttonCell'}>REMOVE</th>
                            <th className={'col-3'}>DISPLAY NAME</th>
                            <th className={'col-3'}>PERMISSION</th>
                            <th className={'col-3'}>FILE</th>
                            <th>ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((member, index) => {
                            const content = get(currentValues, member, '');
                            return (
                                <tr key={index}>
                                    <td className={'buttonCell'}>
                                        <VerbButton
                                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                            fontAwesomeIcon={'fa-trash'}
                                            onClick={() => fields.remove(index)}
                                        />
                                    </td>
                                    <td>{content.name}</td>
                                    <td>{(RESOURCE_PERMISSION_TYPES[content.permissionType] || {}).label}</td>
                                    <td>{content.displayName || content.url}</td>
                                    <td className={'buttonCell'}>
                                        <VerbButton
                                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                            fontAwesomeIcon={'fa-angle-up'}
                                            onClick={() =>
                                                fields.length > 1 && index - 1 >= 0
                                                    ? fields.swap(index, index - 1)
                                                    : null
                                            }
                                            title={'Move Up'}
                                        />
                                        <VerbButton
                                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                            fontAwesomeIcon={'fa-angle-down'}
                                            onClick={() =>
                                                fields.length > 1 && index + 1 < fields.length
                                                    ? fields.swap(index, index + 1)
                                                    : null
                                            }
                                            title={'Move Down'}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </VerbTable>
            );
        }
        return null;
    };

    _handleMediaPropertyChange = (property, value) => {
        this.setState({ [property]: value });
    };

    _handleMediaSave = () => {
        const { fields } = this.props;
        const {
            selectedResourceUrl,
            selectedResourceName,
            selectedResourcePermission,
            selectedResourceDisplayName,
            everythingSector
        } = this.state;

        fields.push({
            name: selectedResourceName,
            displayName: selectedResourceDisplayName,
            url: selectedResourceUrl,
            permissionType: selectedResourcePermission,
            addedDateTime: moment().utc().format()
        });

        this.setState({
            selectedResourceUrl: '',
            selectedResourceName: '',
            selectedResourcePermission: everythingSector
        });
    };

    render() {
        const {
            fields,
            currentValues,
            mediaMetadata,
            label,
            team = {},
            RESOURCE_PERMISSION_TYPES,
            isVerbAdmin,
            isContentAdmin,
            isAccountOwner
        } = this.props;
        const { selectedResourceUrl, selectedResourceName, selectedResourcePermission } = this.state;
        const mediaOptions = (mediaMetadata || [])
            .filter(
                (file) =>
                    (isVerbAdmin ? file.isPublic : false) ||
                    (file.licenses || []).some(
                        (license) => license.parentId === team._id || license.parentId === team.parentId
                    ) ||
                    isVerbAdmin
            )
            .map((file) => ({
                name: file.fileName,
                value: file.key
            }));
        return (
            <div className={'resource-management-section'}>
                <h4>{label}</h4>
                <div className={'row resource-management-form-fields'}>
                    <div className={'media-name-input col-3'}>
                        <TextInput
                            placeholder={'Resource Name'}
                            value={selectedResourceName}
                            onChange={(e) => {
                                this._handleMediaPropertyChange('selectedResourceName', e.target.value);
                            }}
                        />
                    </div>
                    <div className={isVerbAdmin || isContentAdmin ? 'col-8' : 'col-9'}>
                        <VerbSelect
                            placeholder={'Select Resources from Media Library'}
                            className={'bordered'}
                            value={selectedResourceUrl}
                            labelKey={'name'}
                            valueKey={'value'}
                            onChange={({ value, name }) => {
                                this.setState({ selectedResourceUrl: value, selectedResourceDisplayName: name });
                            }}
                            options={mediaOptions || []}
                        />
                    </div>
                    {isVerbAdmin || isContentAdmin || isAccountOwner ? (
                        <div className={'col-1'}>
                            <VerbButton
                                className={'mini-icon-button'}
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                fontAwesomeIcon={'fa-file-search'}
                                href={'/medialibrary'}
                                newTab={true}
                            />
                        </div>
                    ) : null}
                </div>
                <div className={'row resource-management-form-fields'}>
                    <div className={'col-3'}>
                        <VerbSelect
                            placeholder={'Resource permission'}
                            className={'bordered'}
                            value={selectedResourcePermission}
                            labelKey={'label'}
                            valueKey={'value'}
                            onChange={(option) => {
                                this._handleMediaPropertyChange('selectedResourcePermission', option.value);
                            }}
                            options={Object.values(RESOURCE_PERMISSION_TYPES)}
                        />
                    </div>
                    <div className={'col-3 add-resource-button'}>
                        <VerbButton
                            fontAwesomeIcon={'fa-plus'}
                            className={'full-width add-resource-button'}
                            onClick={() =>
                                selectedResourceUrl && selectedResourceName ? this._handleMediaSave() : null
                            }
                            disabled={!selectedResourceUrl || !selectedResourceName}
                            textId={'ADD_RESOURCE'}
                            defaultMessage={'ADD RESOURCE'}
                        />
                    </div>
                    {isVerbAdmin || isContentAdmin || isAccountOwner ? (
                        <>
                            <div className={'col-4'}>
                                <Link to={`/newmedialibraryfile?companyId=${team.parentId}&teamId=${team._id}`}>
                                    <VerbButton buttonText={'UPLOAD NEW MEDIA FILE'} fontAwesomeIcon={'fa-plus'} />
                                </Link>
                            </div>
                            <br />
                        </>
                    ) : null}
                </div>
                {this._buildTable(fields, currentValues)}
            </div>
        );
    }
}
